module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwgAADsIBFShKgAAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMC45bDN+TgAAAJdJREFUOE+1lDEOgCAUQ7kAkwurV/AKjt7P62KbaPKBQgx+hzfQtA3kAyHn7IoUvyBFyxlCBMtNVB6LFAnCCezgqKCWVIZIEYHVFPTYVLYRYOTOVIGi2WmxIDCpY/bY63yxgIEDUMERxaDqQk5ShUYstuP3Qt8jExj8hkJg8r02BMatCireXewHBPyengVhn89hFinOk8MFV/f1uqOJrV0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/procedure_red_old.png
// module id = WQpm
// module chunks = 1